"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryDropdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _dropdownCore = require("../../dropdown-core");

var _getClassesPropType = require("../../../helpers/getClassesPropType");

var _useStyles = require("../../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c1a854218{position:relative;box-shadow:0 5px 15px rgba(0,0,0,.08),0 15px 35px rgba(49,49,93,.1),0 0 0 1px rgba(136,152,170,.1);border-radius:.375rem;background:#fff;overflow:hidden}.c1a854218:not(.ce33925ba) .c90493e9f{max-height:22rem;overflow:auto}.c90493e9f{position:relative;z-index:2}.cea30d486{width:auto}.c991cb62a{padding:1rem 1.25rem;color:var(--color-gray-90);font-size:.875rem;font-weight:600;line-height:1.25rem}.c78604596{margin-top:.3125rem}.cea5101ae{margin-bottom:.3125rem}");
var styles = {
  root: 'c1a854218',
  '--no-scroll': 'ce33925ba',
  content: 'c90493e9f',
  '--view-usual': 'cea30d486',
  '--view-tooltip': 'c991cb62a',
  '--direction-down': 'c78604596',
  '--direction-up': 'cea5101ae'
};

var SecondaryDropdown = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var onOverlayClick = props.onOverlayClick,
      children = props.children,
      active = props.active,
      classes = props.classes,
      position = props.position,
      direction = props.direction,
      dropdownCoreProps = props.dropdownCoreProps,
      noScroll = props.noScroll,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement(_dropdownCore.DropdownCore, (0, _extends2.default)({
    ref: ref,
    active: active,
    onOverlayClick: onOverlayClick,
    position: position,
    direction: direction
  }, dropdownCoreProps), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.direction[direction], cn.view[view], (0, _defineProperty2.default)({}, cn.no.scroll, noScroll))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, children)));
});

exports.SecondaryDropdown = SecondaryDropdown;
var position = ['left', 'right'];
var direction = ['down', 'up'];
var view = ['usual', 'tooltip'];
SecondaryDropdown.modes = {
  position: position,
  direction: direction,
  view: view
};
SecondaryDropdown.propTypes = {
  /* component logic props */
  onOverlayClick: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired,
  active: _propTypes.bool,
  dropdownCoreProps: _propTypes.object,

  /* styling modificators */
  position: (0, _propTypes.oneOf)(position),
  direction: (0, _propTypes.oneOf)(direction),
  view: (0, _propTypes.oneOf)(view),
  noScroll: _propTypes.bool,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondaryDropdown.defaultProps = {
  position: 'left',
  direction: 'down',
  view: 'usual',
  active: false,
  noScroll: false,
  classes: {},
  dropdownCoreProps: {}
};